import request from './financeRequest'

export const ledgerApi = {
  receivables: (params) => request.get('/finance/receivables', { params }),
  receipts: (params) => request.get('/finance/receipts', { params }),
  createReceipt: (data) => request.post('/finance/receipts', data),
  batchConfirmReceipts: (month, data) =>
    request.post('/finance/receipts/batch-confirm', data, { params: { month } }),
  confirmReceipt: (id) => request.post(`/finance/receipts/${id}/confirm`),
  voidReceipt: (id, reason) =>
    request.post(`/finance/receipts/${id}/void`, { reason }),
  otherIncome: () => request.get('/finance/other-income'),
  createIncome: (data) => request.post('/finance/other-income', data),
  confirmIncome: (id) => request.post(`/finance/other-income/${id}/confirm`),
  voidIncome: (id, reason) =>
    request.post(`/finance/other-income/${id}/void`, { reason }),
  expenses: (params) => request.get('/finance/expenses', { params }),
  createExpense: (data) => request.post('/finance/expenses', data),
  confirmExpense: (id) => request.post(`/finance/expenses/${id}/confirm`),
  voidExpense: (id, reason) =>
    request.post(`/finance/expenses/${id}/void`, { reason }),
  expenseCategories: () => request.get('/finance/expenses/categories'),
  createExpenseCategory: (data) =>
    request.post('/finance/expenses/categories', data),
  toggleExpenseCategory: (id, enabled) =>
    request.post(`/finance/expenses/categories/${id}/enabled`, null, {
      params: { enabled },
    }),
  accounts: () => request.get('/finance/accounts'),
  createAccount: (data) => request.post('/finance/accounts', data),
  toggleAccount: (id, enabled) =>
    request.post(`/finance/accounts/${id}/enabled`, null, {
      params: { enabled },
    }),
  accountFlows: (params) => request.get('/finance/accounts/flows', { params }),
  payables: (params) => request.get('/finance/payables', { params }),
  payouts: () => request.get('/finance/payouts'),
  createPayout: (data) => request.post('/finance/payouts', data),
  confirmPayout: (id) => request.post(`/finance/payouts/${id}/confirm`),
  voidPayout: (id, reason) =>
    request.post(`/finance/payouts/${id}/void`, { reason }),
  monthCloses: () => request.get('/finance/month-closes'),
  precheckMonth: (params) =>
    request.get('/finance/month-closes/precheck', { params }),
  closeMonth: (data) => request.post('/finance/month-closes', data),
  reopenMonth: (id, reason) =>
    request.post(`/finance/month-closes/${id}/reopen`, { reason }),
  vouchers: (bizType, bizId) =>
    request.get('/finance/vouchers', { params: { bizType, bizId } }),
  uploadVoucher: (bizType, bizId, file) => {
    const data = new FormData()
    data.append('file', file)
    return request.post('/finance/vouchers', data, {
      params: { bizType, bizId },
    })
  },
}
